import React from 'react';
import { useReveal } from '../lib/useReveal';
import { ShieldCheckIcon } from '../lib/icons';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-91">
      <div className="container mx-auto max-w-3xl" data-id="element-92">
        <div ref={ref1} className={`reveal bg-[#111111] rounded-3xl p-8 md:p-12 border border-[#eab308]/20 shadow-[0_0_40px_rgba(234,179,8,0.1)] text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-93">
          <div className="w-20 h-20 bg-gradient-to-br from-[#eab308] to-[#d4a017] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-94">
            <ShieldCheckIcon className="w-10 h-10 text-[#0f0f1a]" data-id="element-95" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#eab308] mb-6" data-id="element-96">
            Sin riesgo
          </h2>

          <div className="space-y-4 text-gray-300 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-97">
            <p data-id="element-98">
              Revisá el material. Si no es lo que esperabas, te devolvemos el
              dinero.
            </p>
            <p className="text-white font-medium text-xl" data-id="element-99">
              Así de simple. Confiamos en lo que creamos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}